import React from 'react'
import PropTypes from 'prop-types'
import Loading from '../../components/loading/Loading'

const withLoading = WrappedComponent => {
    class LoadingHOC extends React.Component {
        render() {
            const { showBrand, message } = this.props
            const { isFetching } = this.props.informations
            return isFetching ? (
                <Loading showBrand={showBrand} message={message} />
            ) : (
                <WrappedComponent {...this.props} />
            )
        }
    }

    LoadingHOC.propTypes = {
        isFetching: PropTypes.bool,
        informations: PropTypes.object,
        showBrand: PropTypes.bool,
        message: PropTypes.string,
    }

    return LoadingHOC
}

export default withLoading
